export const BOOKING_WIZARD_STEP_COUNT = 2;

export function getBookingWizardStepCount(requiresForm) {
  return requiresForm ? 3 : 2;
}

export function getBookingFormStepIndex(requiresForm) {
  return requiresForm ? 1 : null;
}

export function getBookingConfirmationStepIndex(requiresForm) {
  return requiresForm ? 2 : 1;
}

function getAddBookingStepChrome(stepIndex, requiresForm, t) {
  if (stepIndex === 0) {
    return {
      stepName: t('Details'),
      stepDescription: t('book_amenity_step_details', {
        defaultValue: 'Book amenity for resident.'
      })
    };
  }

  if (requiresForm && stepIndex === getBookingFormStepIndex(true)) {
    return {
      stepName: t('Amenity Form'),
      stepDescription: t('book_amenity_step_form', {
        defaultValue:
          'Review the amenity form and provide consent on behalf of the resident.'
      })
    };
  }

  return {
    stepName: t('Confirmation'),
    stepDescription: t('book_amenity_step_confirm', {
      defaultValue: 'Confirm amenity booking.'
    })
  };
}

export function getAddBookingWizardChromeProps(stepIndex, t, { modalTitle, requiresForm = false }) {
  const { stepName, stepDescription } = getAddBookingStepChrome(stepIndex, requiresForm, t);

  return {
    stepIndex,
    displayTotalSteps: getBookingWizardStepCount(requiresForm),
    title: modalTitle,
    stepName,
    stepDescription
  };
}

export function getEditBookingWizardChromeProps(stepIndex, t, { modalTitle }) {
  return {
    stepIndex,
    displayTotalSteps: BOOKING_WIZARD_STEP_COUNT,
    title: modalTitle,
    stepName: stepIndex === 0 ? t('Details') : t('Confirmation'),
    stepDescription:
      stepIndex === 0
        ? t('edit_booking_step_details', {
            defaultValue: 'Update date and time for this booking.'
          })
        : t('edit_booking_step_confirm', {
            defaultValue: 'Review and confirm booking changes.'
          })
  };
}

export function getEditBlockWizardChromeProps(stepIndex, t, { modalTitle }) {
  return {
    stepIndex,
    displayTotalSteps: BOOKING_WIZARD_STEP_COUNT,
    title: modalTitle,
    stepName:
      stepIndex === 0
        ? t('Block Details', { defaultValue: 'Block Details' })
        : t('Confirmation'),
    stepDescription:
      stepIndex === 0
        ? t('edit_block_step_details', {
            defaultValue: 'Update dates and times for this block.'
          })
        : t('edit_block_step_confirm', {
            defaultValue: 'Review and confirm block changes.'
          })
  };
}

export function getAddBlockWizardChromeProps(stepIndex, t, { modalTitle }) {
  return {
    stepIndex,
    displayTotalSteps: BOOKING_WIZARD_STEP_COUNT,
    title: modalTitle,
    stepName:
      stepIndex === 0
        ? t('Block Details', { defaultValue: 'Block Details' })
        : t('Confirmation'),
    stepDescription:
      stepIndex === 0
        ? t('block_step_details', {
            defaultValue: 'Prevents bookings on specific dates.'
          })
        : t('block_step_confirm', {
            defaultValue: 'Confirm block details.'
          })
  };
}
